module.exports = __webpack_public_path__ + "img/caution-yellow.1e7308b7.svg";